import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DossierRoutingModule } from './dossier-routing.module';
import { ListComponent } from './views/list/list.component';
import { DetailComponent } from './views/list/detail/detail.component';
import { FormsModule } from '@angular/forms';
import { CustomfieldsModule } from 'projects/core/src/common/customfields/customfields.module';
import { WindowModule } from 'projects/core/src/common/window/window.module';
import { WindowlistModule } from 'projects/core/src/common/windowlist/windowlist.module';
import { PaginationModule } from 'projects/core/src/common/pagination/pagination.module';
import { CitiesModule } from 'projects/c1-backend/src/app/modules/cities/cities.module';
import { ToolbarmodelModule } from 'projects/core/src/common/toolbarmodel/toolbarmodel.module';
import { TypeModule } from 'projects/c1-backend/src/app/modules/type/type.module';
import { FilesModule } from 'projects/c1-backend/src/app/modules/files/files.module';
import { DocumentsModule } from 'projects/c1-backend/src/app/views/documents/documents.module';
import { DossierComponent } from './views/dossier/dossier.component';
import { PhasesComponent } from './views/settings/phases/phases.component';
import { DetailPhaseComponent } from './views/settings/phases/detail/detail.component';
import { FieldsModule } from 'projects/c1-backend/src/app/modules/fields/fields.module';
import { SelectfieldcustomModule } from 'projects/core/src/common/selectfieldcustom/selectfieldcustom.module';
import { DeadlinesModule } from 'projects/c1-backend/src/app/views/deadlines/deadlines.module';
import { FiltercontainerModule } from 'projects/c1-backend/src/app/modules/filtercontainer/filtercontainer.module';
import { PreviewComponent } from './views/list/preview/preview.component';
import { Globals } from 'projects/core/src/globals';
import { WindowlistbuttonsModule } from 'projects/core/src/common/windowlistbuttons/windowlistbuttons.module';
import { OverviewsComponent } from './views/settings/overviews/overviews.component';
import { DetailOverviewComponent } from './views/settings/overviews/detail/detail.component';
import { DossierSettingsComponent } from './views/settings/settings.component';
import { NotificationsModule } from 'projects/core/src/common/notifications/notifications.module';
import { AllListComponent } from './views/list/all/all.component';
import { FilterdateModule } from 'projects/c1-backend/src/app/modules/filterdate/filterdate.module';
import { NoteboxModule } from 'projects/c1-backend/src/app/modules/notebox/notebox.module';
import { NgxPageScrollCoreModule } from 'ngx-page-scroll-core';
import { SettingwindowComponent } from 'projects/core/src/common/settingwindow/settingwindow.component';
import { FilterComponent } from './views/list/filter/filter.component';
import { DaysRemainingPipe } from 'projects/c1-backend/src/app/pipes/days-remaining.pipe';

@NgModule({
  declarations: [
    ListComponent,
    DetailComponent,
    DossierComponent,
    PhasesComponent,
    DetailPhaseComponent,
    PreviewComponent,
    OverviewsComponent,
    DetailOverviewComponent,
    DossierSettingsComponent,
    AllListComponent,
    FilterComponent
  ],
exports:[
  ListComponent,
  DetailComponent,
  PreviewComponent,
  AllListComponent,
  FilterComponent
],
  imports: [
    CommonModule,
    DossierRoutingModule,
    FormsModule,
    NotificationsModule,
    CustomfieldsModule,
    WindowModule,
    WindowlistModule,
    PaginationModule,
    CitiesModule,
    ToolbarmodelModule,
    TypeModule,
    FilesModule,
    DocumentsModule,
    FieldsModule,
    SelectfieldcustomModule,
    FilesModule,
    DeadlinesModule,
    FiltercontainerModule,
    WindowlistbuttonsModule,
    FilterdateModule,
    NoteboxModule,
    NgxPageScrollCoreModule,
    SettingwindowComponent,
    DaysRemainingPipe
  
  ]
})
export class DossierModule { 
  constructor(){
    Globals.parameters.loadModulesEvent.subscribe((result)=>{
    

   
    Globals.permissions.addPermissionRule("dossier","add","Creazione");
    Globals.permissions.addPermissionRule("dossier","save","Salvataggio");
    Globals.permissions.addPermissionRule("dossier","delete","Eliminazione");
    Globals.permissions.addPermissionRule("dossier","allowManageType","Consenti gestione tipologie");
    Globals.permissions.addPermissionRule("dossier","showRecordsOnlyUser","Mostra solo le pratiche assegnate");
    Globals.permissions.addPermissionRule("dossier","showOnlyDataSection","Mostra solo sezione Dati");
            

    Globals.parameters.createParam(
      "dossier",
      "default_dashboard_view",
      "Visualizzazione di default nella dashboard",
      "select",
    
      [
          {"label":"Riepilogo","value":"overview"},
          {"label":"Lista pratiche","value":"list"},
          
      ]
    );

    
      Globals.parameters.createParam(
          "dossier",
          "id_notification_phase",
          "Notifica per cambio di fase",
          "notification"
      );


      Globals.parameters.createParam(
        "dossier",
        "show_default_header_table",
        "Mostra colonne di default nella tabella",
        "boolean"
      );

      Globals.parameters.createParam(
        "dossier",
        "cols_overview",
        "Numero colonne nel riepilogo",
        "number"
      );

      Globals.parameters.createParam(
        "dossier",
        "user_assignment",
        "Associazione utente (crezione record)",
        "select",
        [
          {"label":"Utente corrente","value":"currentuser"},
          {"label":"Utente dell'anagrafica","value":"addressuser"},
          
        ],"currentuser"
      );

      Globals.parameters.createParam(
        "dossier",
        "enableNotifyChangePhase",
        "Abilita notifica per cambio di fase",
        "boolean"
      );

     
      

    });
  }

}
